import ContentstackLivePreview from '@contentstack/live-preview-utils';

import { previewStack } from './previewStack';
import {
  API_KEY,
  CONTENTSTACK_APP_HOST,
  ENVIRONMENT,
  LIVE_PREVIEW_ENABLED,
} from './settings';

export const initLivePreview = async (): Promise<void> => {
  if (!LIVE_PREVIEW_ENABLED) return;

  try {
    await ContentstackLivePreview.init({
      stackSdk: previewStack,
      ssr: false,
      mode: 'builder',
      enable: true,
      editButton: { enable: true },
      stackDetails: {
        apiKey: API_KEY,
        environment: ENVIRONMENT,
      },
      clientUrlParams: {
        protocol: 'https',
        host: CONTENTSTACK_APP_HOST,
        port: 443,
      },
    });
  } catch (error) {
    console.error('[live-preview] init failed:', error);
  }
};

export { ContentstackLivePreview };
